import React from "react";

import ArrowRightBigIcon from "images/icons/arrow-right-big-icon.inline.svg";
import ArrowRight from "images/icons/arrow-right.inline.svg";

import { Link } from "../../utils/customLink";
import Image from "../image";

/**
 * type
 * 1 : Volunteer page conservation card
 * 2 : Volunteer page community card
 * 3 : Content Block card
 * 5 : Internship grid block
 */
const ContentCard = ({
  title,
  subtitle,
  titleIcon = "",
  description,
  imgUrl,
  type,
  url,
  descriptionAsComponent,
  ellipse = false,
  innerContainerFullheight = false,
  linkTitle = "View programs",
  externalLink = false,
  titleClass = "",
  subTitleClass = "text-sm text-normal p-2 bg-yellow-standard planet:bg-gray-standard rounded-t-md sm:rounded-md hidden sm:block text-white planet:text-white",
  subTitleMobileClass = "text-sm text-normal p-2 bg-yellow-standard planet:bg-gray-standard rounded-t-md sm:rounded-md sm:hidden absolute right-0 bottom-0 mx-2 w-1/2 text-white planet:text-white text-center",
  imgHeight = "h-24",
  imgClass = "object-cover object-center w-full rounded-t-md",
  imgContainerClass = "relative",
  descriptionContainerClass = "pt-3 pb-4",
  descriptionClass = "text-sm text-left text-black-lighter planet:text-gray-generic",
  contentWrapperClass = "flex flex-col p-6 rounded-b bg-white planet:gvi-dark-gray-bg",
  headerTitleContainerClass = "pb-4 flex flex-row items-center border-b border-gray-lighter justify-between text-black-lighter planet:text-gray-generic",
  cardBoxCoverClass = "sm:gvi-program-card-box bg-transparent",
  cardCtaContainerClass = "",
  outerCointainerExtra = ""
}) => {
  const typeOuterContainerClass = {
    3: "drop-shadow-2xl",
    5: "drop-shadow-xl sm:drop-shadow-6xl ",
    9: "drop-shadow-2xl"
  };
  const typeHeaderTitleContainerClass = {
    3: "h3 planet:font-semibold",
    4: "h3",
    5: "h3 planet:font-semibold",
    9: "h3 planet:font-semibold"
  };
  const typeUrlContainerClass = {
    1: "sm:w-5/12",
    3: "sm:w-5/12 sm:ml-0",
    4: "sm:w-5/12 sm:ml-0",
    5: "sm:w-1/2 planet:sm:w-5/12 sm:ml-0",
    9: "sm:w-5/12 sm:min-w-max sm:ml-0"
  };

  return (
    <div
      className={`outer-container w-full h-full ${outerCointainerExtra} ${
        typeOuterContainerClass[type] ?? ""
      }`}
    >
      <div
        className={`inner-container relative ${
          innerContainerFullheight ? "h-full" : ""
        }`}
      >
        <div className={`card-box-cover ${cardBoxCoverClass}`}>
          {imgUrl && (
            <div className={imgContainerClass}>
              <Image
                imageAlt={""}
                image={""}
                imageClass={`${imgClass} ${imgHeight}`}
                sourceUrl={imgUrl}
              />
              {subtitle && (
                <div
                  className={`${subTitleMobileClass}`}
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />
              )}
            </div>
          )}
          <div className={`card-box-content ${contentWrapperClass}`}>
            <div
              className={`card-box-header-title ${headerTitleContainerClass} ${
                typeHeaderTitleContainerClass[type] ?? ""
              }`}
            >
              {titleIcon && (
                <div className="pr-5">
                  <Image
                    imageAlt={""}
                    image={""}
                    imageClass="object-contain object-center h-[24px] w-[24px]"
                    sourceUrl={titleIcon}
                  />
                </div>
              )}
              <div
                className={titleClass}
                dangerouslySetInnerHTML={{ __html: title }}
              />
              {subtitle && (
                <div
                  className={subTitleClass}
                  dangerouslySetInnerHTML={{ __html: subtitle }}
                />
              )}
            </div>
            <div className={`card-description ${descriptionContainerClass}`}>
              {descriptionAsComponent ? (
                descriptionAsComponent
              ) : (
                <div
                  className={descriptionClass}
                  dangerouslySetInnerHTML={{
                    __html:
                      ellipse && description.length > 65
                        ? `${description.substring(0, 65) + "[...]"}`
                        : description
                  }}
                />
              )}
            </div>
            {url && (
              <div
                className={`${
                  typeUrlContainerClass[type] ?? ""
                } w-full card-action ml-auto z-10 ${cardCtaContainerClass}`}
              >
                <Link
                  to={url}
                  target={externalLink ? "_gviblank" : "_self"}
                  className="group flex flex-row items-center justify-center px-2 py-2
                bg-inherit hover:bg-black-lighter planet:hover:bg-white
                border border-black-lighter hover:border-white planet:border-white planet:hover:border-white rounded-full planet:rounded-sm
                text-sm text-black-lighter hover:text-white planet:text-white planet:hover:text-gray-darker"
                >
                  <p className="text-base font-bold pr-2">{linkTitle}</p>
                  <ArrowRightBigIcon className="planet:hidden fill-black-lighter group-hover:fill-white" />
                  <ArrowRight className="hidden planet:block w-3 h-3 stroke-white group-hover:stroke-gray-darker" />
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentCard;
